import { lazy, Suspense } from 'react'
import { Layout } from '@/components/layout/Layout'
import { HomePage } from '@/pages/HomePage'
import { NotFoundPage } from '@/pages/NotFoundPage'

// Legal pages carry long texts: split them out so they never weigh on the home
// page. They are still in the prerendered HTML (scripts/prerender.mjs waits for
// every lazy chunk), so crawlers and first paint don't depend on JavaScript.
const PrivacyPage = lazy(() => import('@/pages/PrivacyPage').then((m) => ({ default: m.PrivacyPage })))
const TermsPage = lazy(() => import('@/pages/TermsPage').then((m) => ({ default: m.TermsPage })))
const AccessibilityPage = lazy(() =>
  import('@/pages/AccessibilityPage').then((m) => ({ default: m.AccessibilityPage })),
)

// Every link on the site is a plain <a href>: each page is a full,
// prerendered document, so a path → page lookup replaces a client router.
const PAGES: Record<string, () => JSX.Element> = {
  '/': () => <HomePage />,
  '/privacy': () => <PrivacyPage />,
  '/terms': () => <TermsPage />,
  '/accessibility': () => <AccessibilityPage />,
}

/** Normalize "/privacy/" → "/privacy" so trailing slashes resolve too. */
export function normalizePath(pathname: string): string {
  const trimmed = pathname.replace(/\/+$/, '')
  return trimmed === '' ? '/' : trimmed
}

/** The page for a path, shared by the browser (main.tsx) and the prerender. */
export function AppRoutes({ path }: { path: string }) {
  const Page = PAGES[normalizePath(path)]
  return (
    <Layout>
      <Suspense fallback={null}>{Page ? <Page /> : <NotFoundPage />}</Suspense>
    </Layout>
  )
}
